import { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useMemberAuth, useAdminAuth } from "../lib/auth";
import ProductCard from "../components/ProductCard";

const MembersCatalog = () => {
  const { isAuthed: isMember, logout } = useMemberAuth();
  const { isAuthed: isAdmin } = useAdminAuth();
  const allowed = isMember || isAdmin;
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!allowed) return;
    api
      .get("/members/products")
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [allowed]);

  if (!allowed) return <Navigate to="/members/login" replace />;

  return (
    <div className="section-pad py-16" data-testid="members-catalog-page">
      <div className="flex items-end justify-between mb-16">
        <div>
          <h1 className="font-display text-5xl sm:text-7xl uppercase tracking-tighter leading-none">
            Members
          </h1>
          {isAdmin && !isMember && (
            <div className="mt-3 status-pill solid" data-testid="admin-preview-badge">Admin preview</div>
          )}
        </div>
        {isMember ? (
          <button onClick={logout} className="btn-ghost" data-testid="member-logout-btn">Sign Out</button>
        ) : null}
      </div>
      {loading ? null : products.length === 0 ? (
        <div className="text-sm text-black/40">No pieces.</div>
      ) : (
        <div className="grid gap-10 md:gap-14 sm:grid-cols-2 lg:grid-cols-3" data-testid="members-catalog-grid">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} hrefBase="/members/product" testIdPrefix="member-product" />
          ))}
        </div>
      )}
      <div className="mt-16 border-t hairline pt-8 text-xs text-black/50">
        <Link to="/" className="hover:opacity-60">← Store</Link>
      </div>
    </div>
  );
};

export default MembersCatalog;
